import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { map } from 'rxjs/operators';
import { CustomerProjectPhaseActivity } from '../../../customer-project-phase-activity.interface';
import { LocalStorage } from '../../../local-storage.class';
import { ConfirmDialogService } from '../../../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerProjectPhaseActivityService } from '../../../services/customer-project/customer-project-phase-activity.service';

@Component({
    selector: 'app-customer-project-phase-activity-edit-dialog',
    templateUrl: './customer-project-phase-activity-edit-dialog.component.html',
    standalone: false,
})
export class CustomerProjectPhaseActivityEditDialogComponent implements OnInit {
    form: FormGroup;
    fc: {
        id: FormControl;
        name: FormControl;
        assignee: FormControl;
        deadline: FormControl;
        executed: FormControl;
        customer_projectphase_id: FormControl;
        order: FormControl;
        user_id: FormControl;
    };

    assignees: {
        user_id: number;
        name: string;
    }[];
    assignee: {
        user_id: number;
        name: string;
    };

    saving = false;

    constructor(
        private dialog: MatDialogRef<CustomerProjectPhaseActivityEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public phaseActivity: CustomerProjectPhaseActivity,
        private confirmDialog: ConfirmDialogService,
        private customerProjectPhaseActivityService: CustomerProjectPhaseActivityService
    ) {}

    ngOnInit(): void {
        this.fc = {
            id: new FormControl(this.phaseActivity.id),
            name: new FormControl(this.phaseActivity.name, Validators.required),
            assignee: new FormControl(this.phaseActivity.assignee),
            user_id: new FormControl(this.phaseActivity.user_id),
            deadline: new FormControl(this.phaseActivity.deadline),
            executed: new FormControl(this.phaseActivity.executed),
            customer_projectphase_id: new FormControl(this.phaseActivity.customer_projectphase_id),
            order: new FormControl(this.phaseActivity.order),
        };
        this.form = new FormGroup(this.fc);
        this.assignees = [
            { user_id: null, name: 'OG' },
            { user_id: null, name: 'ON' },
        ];
        this.customerProjectPhaseActivityService
            .assignees(LocalStorage.getCustomer()['id'])
            .pipe(map(d => d.data))
            .subscribe(users => {
                this.assignees = this.assignees.concat(
                    users.map(u => {
                        return { user_id: u.id, name: u.name };
                    })
                );
                this.assignee = this.assignees.find(
                    a => a.name === this.phaseActivity.assignee && a.user_id === this.phaseActivity.user_id
                );
            });
    }

    assigneeChange(event: MatSelectChange) {
        this.fc.assignee.setValue(event.value.name);
        this.fc.user_id.setValue(event.value.user_id);
    }

    delete() {
        this.confirmDialog
            .confirm('Verwijderen', `Weet je zeker dat je deze activiteit wilt verwijderen?`, 'Verwijderen', 'Behouden')
            .then(() =>
                this.customerProjectPhaseActivityService.delete(this.phaseActivity.id).subscribe(result => {
                    Object.assign(this.phaseActivity, result.data);
                    this.dialog.close(this.phaseActivity);
                })
            )
            .catch(() => {});
    }

    save() {
        this.customerProjectPhaseActivityService.save(this.form.value).subscribe(result => {
            Object.assign(this.phaseActivity, result.data);
            this.dialog.close(this.phaseActivity);
        });
    }
}
